import { airlinePath, airlineResultsPath } from './airlines';
import { ARTICLE, FAQ_INTRO, FAQS, HERO, META } from './content';

export function buildAirlinePack(airline) {
  return {
    airline,
    path: airlinePath(airline.slug),
    resultsPath: airlineResultsPath(airline.slug),
    meta: META,
    hero: HERO,
    article: ARTICLE,
    faqIntro: FAQ_INTRO,
    faqs: FAQS,
  };
}
